import React from 'react'
import AllExpense from '../../../components/Manage/Expenses/AllExpense'

const ExpensePage = () => {
    return (
        <>
            <AllExpense />
        </>
    )
}

export default ExpensePage
